import React from 'react';
import { cleanPhoneNumber } from '../../../utils/formatters';

interface BrokerDataSectionProps {
  formData: any;
  setFormData: (data: any) => void;
  isClientView: boolean;
  labelStyle: string;
  inputStyle: string;
  readOnlyStyle: string;
  isBrokerEmailInvalid: boolean | string;
  countryCodes: { value: string; label: string }[];
}

export const BrokerDataSection: React.FC<BrokerDataSectionProps> = ({
  formData, setFormData, isClientView, labelStyle, inputStyle, readOnlyStyle, isBrokerEmailInvalid, countryCodes
}) => {
  return (
    <section className="space-y-4">
      <h4 className="text-sm font-black text-[#00234F] uppercase border-b pb-2">
        {isClientView ? 'Tus Datos' : 'Datos del broker QUIÉN realizará la visita'}
      </h4>
      {!isClientView && (
        <div className="bg-amber-50 border-l-4 border-amber-500 p-3 rounded-r-xl animate-fade-in">
          <p className="text-[11.5px] text-amber-800 font-bold uppercase tracking-tight leading-relaxed">
            ⚠️ Si eres una inmobiliaria, por favor agrega los datos del comercial quién va a estar en la visita y no los de la inmobiliaria.
          </p>
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className={labelStyle}>{isClientView ? 'Tu Nombre *' : 'Nombre Completo *'}</label>
          <input 
            type="text" 
            value={formData.nombre_broker} 
            onChange={e => setFormData({...formData, nombre_broker: e.target.value})} 
            className={inputStyle} 
            placeholder={isClientView ? "Ej: Pepito Perez" : ""}
            required 
          />
        </div>
        {!isClientView && (
          <div>
            <label className={labelStyle}>Cédula *</label>
            <input 
              type="text" 
              value={formData.cc_broker} 
              onChange={e => setFormData({...formData, cc_broker: e.target.value})} 
              className={inputStyle} 
              required 
            />
          </div>
        )}
        <div>
          <label className={labelStyle}>{isClientView ? 'Tu Celular *' : 'Celular *'}</label>
          <div className="flex gap-2">
            <select 
              value={formData.countryCode_broker} 
              onChange={e => setFormData({...formData, countryCode_broker: e.target.value})} 
              className="w-24 border border-gray-300 rounded-lg text-xs font-bold uppercase px-2 py-2 bg-white text-gray-700 shadow-sm focus:ring-2 focus:ring-sky-500/20 focus:border-sky-500 focus:outline-none transition-all"
            >
              {countryCodes.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
            <input 
              type="tel" 
              value={formData.celular_broker} 
              onChange={e => setFormData({...formData, celular_broker: e.target.value})} 
              onBlur={e => setFormData({...formData, celular_broker: cleanPhoneNumber(e.target.value)})}
              className={inputStyle} 
              placeholder={isClientView ? "3001234567" : ""}
              required 
            />
          </div>
        </div>
        <div>
          <label className={labelStyle}>{isClientView ? 'Tu Correo Electrónico *' : 'Email (No editable)'}</label>
          <input 
            type="email" 
            value={formData.email_broker} 
            onChange={isClientView ? e => setFormData({...formData, email_broker: e.target.value}) : undefined}
            className={isClientView ? `${inputStyle} ${isBrokerEmailInvalid ? 'border-red-500 bg-red-50' : ''}` : readOnlyStyle} 
            placeholder={isClientView ? "correo@gmail.com" : ""}
            readOnly={!isClientView} 
          />
          {isClientView && isBrokerEmailInvalid && <p className="text-[9px] text-red-600 font-bold mt-1 uppercase tracking-tighter">Formato de correo inválido</p>}
        </div>
      </div>
    </section>
  );
};
